<div class="pswp__preloader__icn" [ngStyle]="{'width': size + 'px', 'height': size + 'px'}" [ngClass]="{'center': center}">
  <div class="pswp__preloader__cut" [ngStyle]="{'width': size/2 + 'px', 'height': size + 'px'}">
    <div class="pswp__preloader__donut" [ngStyle]="{'width': size + 'px', 'height': size + 'px', 'opacity': opacity}"></div>
  </div>
</div>
